import { Box } from "@chakra-ui/react";
import { FunctionComponent, ReactElement, ReactNode, useState } from "react";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";

interface LayoutWrapperProps {
	children: ReactNode;
}

const LayoutWrapper: FunctionComponent<LayoutWrapperProps> = (props: LayoutWrapperProps): ReactElement => {
	const { children } = props;
	const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

	return (
		<Box display="flex" flexDirection="column" overflow="hidden" width="100%" height="100%">
			<Box height="80px" boxShadow="2px 5px 7px 0px rgb(0 0 0 / 9%)">
				<Header />
			</Box>
			<Box display="flex" gridTemplateColumns={sidebarOpen ? "20vw 80vw" : "5vw 95vw"} overflow="hidden" flex="1">
				<Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={() => setSidebarOpen(!sidebarOpen)} />
				<Box display="flex" flexDirection="column" flex="1" overflow="auto">
					{children}
				</Box>
			</Box>
		</Box>
	);
};

export default LayoutWrapper;
